import FeedbackChecker from './FeedbackChecker';

export default FeedbackChecker;
